import layoutHeaderAside from "@/layout/header-aside"
const files = require.context("./", true, /\.js$/)

let componentMaps = {
  layoutHeaderAside: layoutHeaderAside,
  userManager: () => import("@/pages/admin/user"),
  groupManager: () => import("@/pages/admin/group"),
  menuManager: () => import("@/pages/admin/menu"),
  gateLogManager: () => import("@/pages/admin/gateLog"),
  groupTypeManager: () => import("@/pages/admin/groupType"),
  onlineManager: () => import("@/pages/admin/online"),

  personList: () => import("@/pages/workbench/person/personList"),
  classesList: () => import("@/pages/workbench/classes/classesList"),
  activityList: () => import("@/pages/workbench/activity/activityList"),
  activityUserList: () => import("@/pages/workbench/activity/activityUserList"),
  orderList: () => import("@/pages/workbench/activity/orderList"),

  
}

files.keys().forEach(key => {
  if (key === "./index.js") return
  Object.assign(componentMaps, files(key).default)
})
export default componentMaps
